var map = {
	"./404/404.scss": "./src/block/common/404/404.scss",
	"./bread-crumbs/bread-crumbs.scss": "./src/block/common/bread-crumbs/bread-crumbs.scss",
	"./common-banner/common-banner.scss": "./src/block/common/common-banner/common-banner.scss",
	"./form/form.scss": "./src/block/common/form/form.scss",
	"./subscribe-form/subscribe-form.scss": "./src/block/common/subscribe-form/subscribe-form.scss",
	"./success/success.scss": "./src/block/common/success/success.scss",
	"./text-with-bg/text-with-bg.scss": "./src/block/common/text-with-bg/text-with-bg.scss",
	"./title-with-ul/title-with-ul.scss": "./src/block/common/title-with-ul/title-with-ul.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/block/common sync recursive ^\\.\\/[^/]+\\/[^/.]+\\.(js%7Ccss%7Cscss%7Csass%7Cless)$";